// Web-safe barrel: only platform-split entries (with `.web.ts` no-ops) + pure config.
// Do NOT re-export fcm-service/notifee-service/register-background-handlers(native) here —
// that would pull native modules into the web bundle.
export { usePushNotifications } from './use-push-notifications';
export { registerBackgroundHandlers } from './register-background-handlers';
export { DEFAULT_CHANNEL_ID } from './notification-config';
